<template>
  <!-- <div class="w-auto h-auto collapse navbar-collapse max-height-vh-100 h-100" id="sidenav-collapse-main"> -->
  <div class="w-auto h-auto collapse navbar-collapse h-100" id="sidenav-collapse-main">
    <ul class="navbar-nav">
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="dashboard"
          navText="Dashboard">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">dashboard</i>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="bookings"
          navText="Trip Bookings">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">bookings</i>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="contacts" navText="Contacts">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">contacts</i>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="adventures"
          navText="Adventure">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">adventure</i>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="tours" navText="Tour Plan">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">tour Plan</i>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="trips" navText="Trip">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">trip</i>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="tripQuestions"
          navText="Trip Questions">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">trip-question</i>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="activities"
          navText="Activity">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">activity</i>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="adventureActivities"
          navText="Adventure Activites">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">adventure-activities</i>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="adventureFitnessLevels"
          navText="Adventure Fitness Levels">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">adventure-fitness-level</i>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="adventureTripTypes"
          navText="Adventure Trip Types">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">adventure-trip-types</i>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="includedItems"
          navText="Included Items">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">included-items</i>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="excludedItems"
          navText="Excluded Items">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">excluded-item</i>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item  mb-5">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="planYourTrip"
          navText="Plan Your Trip">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">plan-your-trip</i>
          </template>
        </sidenav-collapse>
      </li>
      <!-- <li class="nav-item mb-5">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="notifications"
          navText="Notifications">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">notifications</i>
          </template>
        </sidenav-collapse>
      </li> -->

      <!-- <li class="mt-3 nav-item">
        <h6 class="text-xs ps-4 text-uppercase font-weight-bolder text-white"
          :class="this.$store.state.isRTL ? 'me-4' : 'ms-2'">
          ACCOUNT PAGES
        </h6>
      </li> -->

      <!-- <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="user-profile"
          navText="User Profile">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">person</i>
          </template>
        </sidenav-collapse>
      </li> -->
      <!-- <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="users" navText="Users">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">people</i>
          </template>
        </sidenav-collapse>
      </li> -->
    </ul>

  </div>
</template>
<script>
import SidenavCollapse from "./SidenavCollapse.vue";

export default {
  name: "SidenavList",
  props: {
    cardBg: String
  },
  data() {
    return {
      title: "Soft UI Dashboard PRO",
      controls: "dashboardsExamples",
      isActive: "active"
    };
  },
  components: {
    SidenavCollapse
  },
  methods: {
    getRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[1];
    },
    logout() {
      this.$store.dispatch("auth/logout");
    }
  }
};
</script>
